/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { MenuItem } from '@kanzi-apes/kanzi-prime-ui';
import {
  LocationModel,
  LocationFilterModel,
  LocationListModel,
  ConfigTableModel,
  CustomerModel,
} from '@kanzi-apes/kanzi-models';
import * as fromCustomer from '@kanzi-apes/kanzi-customer';
import * as fromLocations from '../../reducers';
import * as Locations from '../../actions';
import { Router } from '@angular/router';
import { AlertConfirmService } from '@kanzi-apes/kanzi-alerts';
import { BreadcrumbService } from '@kanzi-apes/kanzi-ui';

/**
 * @deprecated Since version 2.0.0 - Use WarehouseListComponent or UbicacionListComponent instead
 * 
 * This component uses legacy NgRx state management and is no longer maintained.
 * 
 * Migration Guide:
 * - For warehouse (type=WAREHOUSE) management: Use `WarehouseListComponent` at route `/locations/warehouses/list`
 * - For ubicaciones (type!=WAREHOUSE) management: Use `UbicacionListComponent` at route `/locations/ubicaciones/list`
 * - New components use TanStack Query for state management
 * - New components have better UX with TreeTable for hierarchical data
 * - New components include prefetch optimization and better loading states
 * 
 * Example routing update:
 * ```typescript
 * // OLD:
 * { path: 'list', component: LocationListComponent }
 * 
 * // NEW:
 * { path: 'warehouses/list', component: WarehouseListComponent }
 * { path: 'ubicaciones/list', component: UbicacionListComponent }
 * ```
 * 
 * See documentation:
 * - libs/kanzi-location/docs/FASE-2-RESUMEN.md (Warehouses)
 * - libs/kanzi-location/docs/FASE-3-RESUMEN.md (Ubicaciones)
 * - libs/kanzi-location/docs/MIGRATION.md (Migration guide)
 */
@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'app-location-list',
    templateUrl: './location-list.component.html',
    styleUrls: ['./location-list.component.scss'],
    standalone: false
})
export class LocationListComponent implements OnInit {
  breadcrumbMenu: MenuItem[] = [];
  emptyItems: boolean = false;

  customer_id: number = 0;

  pending$ = this.store.pipe(select(fromLocations.getLocationsLoading));
  loaded$ = this.store.pipe(select(fromLocations.getLocationLoaded));
  configTable: ConfigTableModel | null = null;
  cols: any[] = [];
  locations$: Observable<LocationListModel | null> = this.store.pipe(
    select(fromLocations.getLocationsList)
  );
  customerSelected$: Observable<CustomerModel | null> = this.store.pipe(
    select(fromCustomer.getCustomerSelected)
  );
  locationToDelete: LocationModel | null = null;
  filters: LocationFilterModel = { page: 1, page_size: 50 };
  // deleteLocationComplete$: Observable<CustomerModel> = this.store.pipe(
  //   select(fromLocations.)
  // );

  constructor(
    private store: Store<fromLocations.State>,
    private router: Router,
    private confirmService: AlertConfirmService,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit() {
    this.breadcrumbService.setItems([
      {
        label: 'Listado locaciones',
        icon: 'fa-list',
      },
    ]);

    this.configTable = {
      sortMode: 'single',
      paginator: true,
      rows: 50,
      options: {
        view: true,
        delete: false,
        edit: true,
      },
      downloadFile: false,
      fileName: 'Listado_Locaciones',
      search: true,
      lazy: true,
      simple: false,
      filters: {
        date: true,
        fields: true,
      },
    };
    this.cols = [
      { field: 'display_name', header: 'Nombre', sortable: false },
      {
        field: 'created_by',
        subfield: 'username',
        header: 'Creado Por',
        sortable: true,
      },
      { field: 'created', header: 'Fecha Creación', sortable: false },
      { field: 'type', subfield: 'name', header: 'Tipo', sortable: false },
      {
        field: 'parent',
        subfield: 'display_name',
        header: 'Pertenece a',
        sortable: false,
        pipe: true,
        pipe_name: 'contactType',
        filterField: 'type_contact',
        filterOptions: [],
        labelFilter: 'Tipos',
      },
    ];
    this.customerSelected$.subscribe((customer) => {
      if (customer) {
        this.customer_id = customer.id;
        this.filters = {
          ...this.filters,
          customer_id: this.customer_id,
        };
        this.store.dispatch(new Locations.LoadList(this.filters));
      }
    });

    this.loaded$.pipe(filter((value) => value)).subscribe(() =>
      this.store.dispatch(
        new Locations.LoadList({
          page: 1,
          page_size: 50,
          customer_id: this.customer_id,
        })
      )
    );
  }

  FilterData(filter: LocationFilterModel) {
    this.filters = {
      ...this.filters,
      ...filter,
    };
    this.store.dispatch(new Locations.LoadList(this.filters));
  }

  pagination(event: LocationFilterModel) {
    this.filters = {
      ...this.filters,
      ...event,
    };
    this.store.dispatch(new Locations.LoadList(this.filters));
  }

  /**
   *
   * @param event {Contact} Contact data.
   *
   * Function to route the app to Contact detail.
   */
  selected(event: any) {
    this.router.navigate(['configurations/location/detail', event.id]);
  }
  edited(event: any) {
    this.router.navigate(['configurations/location/edit', event.id]);
  }

  /**
   *
   * @param event {Contact} Contact data.
   *
   * Function to dispatch the Delete action to the server.
   */
  deletes(event: any) {
    // this.store.dispatch(new Contacts.LoadComplete(event));

    console.log('eventos', event);
    this.locationToDelete = event;
    this.confirmService.confirm(
      'Desea eliminar la locación ' + event.name + '?',
      'Confirmar Eliminación'
    );
  }
  activeFilter(filter: LocationFilterModel) {
    this.filters = {
      ...this.filters,
      ...filter,
    };
    this.store.dispatch(new Locations.LoadList(this.filters));
  }
  restoreData(data: any) {
    if (data) {
      this.filters = {
        page: 1,
        page_size: 50,
        customer_id: this.customer_id,
      };
      this.store.dispatch(new Locations.LoadList(this.filters));
    }
  }

  /**
   *
   * @param event {Boolean}
   *
   * Function to confirm the Delete action.
   */
  deleteConfirm(event: any) {
    if (event && this.locationToDelete) {
      this.store.dispatch(new Locations.Delete(this.locationToDelete));
    }
  }
}
